import styled, { css } from 'styled-components';

const DEFAULT_AVATAR_SIZE = 40;
const DEFAULT_FONT_SIZE = 15;

export interface NamedAvatarContainerProps {
	size?: number;
	$background?: string;
}

export const NamedAvatarContainer = styled.div<NamedAvatarContainerProps>`
	${({ theme, $background, size }) => css`
		width: ${size ? size : DEFAULT_AVATAR_SIZE}px;
		height: ${size ? size : DEFAULT_AVATAR_SIZE}px;
		border-radius: ${theme.radii.full};
		background-color: ${$background ? $background : theme.colors.brand.accent[300]};
		display: grid;
		place-content: center;
		color: ${theme.colors.neutral[100]};
		text-transform: uppercase;
		font-size: ${size ? (DEFAULT_FONT_SIZE * size) / DEFAULT_AVATAR_SIZE : DEFAULT_FONT_SIZE}px;
		font-weight: ${theme.fontWeights.medium};
	`};
`;
